import request from '@/utils/request'
import { parseTime } from '@/utils'

// 分页查询沟通记录用户列表
export function getMsgSummaryPager(query) {
  const response = request({
    url: '/UserMsgLog/GetMsgSummaryPager',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data.list) {
        data.list = data.list.map(item => {
          item.lastCreateTime = parseTime(item.lastCreateTime, '{y}-{m}-{d} {h}:{i}')
          // item.isOnline = `${item.isOnline}`
          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 分页查询（跟某个用户的对话记录）
export function fetchChatMsgPager(query) {
  const response = request({
    url: '/UserMsgLog/GetChatMsgRecord',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      let { code, data } = res
      if (code >= 0 && data) {
        data = data.reverse().map(item => {
          item.createTime = parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
          // item.isOnline = `${item.isOnline}`
          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 获取用户状态
export function getUserStatus(userId) {
  return request({
    url: '/UserMsgLog/GetUserStatus',
    method: 'get',
    params: { userId }
  })
}

// 更新消息已读
export function updateMsgReadState(fromUserId) {
  return request({
    url: '/UserMsgLog/UpdateMsgReadState',
    method: 'get',
    params: { fromUserId }
  })
}



// WEBPACK FOOTER //
// ./src/api/m/userChat.js